export const ROLE_FINSIGHT_ID = 'b1d54c57-5b2c-4d1a-80dd-8fdf28d6bc8d';
export const ROLE_INVESTOR_ID = '952c3cc6-4539-4d66-b787-8a9b596d8a9c';
